export enum CreditCardName {
  ZENIT = 'iberia_card_zenit',
  AIRE = 'iberia_card_aire',
  ICON = 'iberia_card_icon',
}

export const useIberiaCardParams = () => {
  const getIberiaCardParams = (creditCardType: number) => {
    switch (creditCardType) {
      case 71:
        return { name: CreditCardName.ZENIT, contrastText: '#000' };
      case 72:
        return { name: CreditCardName.AIRE, contrastText: '#000' };
      case 45:
        return { name: CreditCardName.ICON, contrastText: '#fff' };
    }
  };

  return {
    getIberiaCardParams,
  };
};
